import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronDown, Loader2 } from "lucide-react";

export function FipeCombobox({ options = [], value, display, onSelect, placeholder, searchPlaceholder = "Buscar...", loading, disabled, testid }) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled || loading}
          data-testid={testid}
          className={`w-full h-12 px-4 flex items-center justify-between gap-2 rounded-sm border border-border bg-white text-left transition-colors
            hover:border-obsidian focus:outline-none focus:ring-2 focus:ring-obsidian focus:ring-offset-1
            disabled:opacity-50 disabled:cursor-not-allowed ${display ? "text-foreground" : "text-muted-foreground"}`}
        >
          <span className="truncate font-500">{display || placeholder}</span>
          {loading ? <Loader2 className="w-4 h-4 animate-spin shrink-0" /> : <ChevronDown className="w-4 h-4 shrink-0 opacity-60" />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 rounded-sm w-[--radix-popover-trigger-width]" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Nada encontrado.</CommandEmpty>
            <CommandGroup>
              {options.map((opt) => (
                <CommandItem
                  key={opt.codigo}
                  value={opt.nome}
                  data-testid={testid ? `${testid}-opt-${opt.codigo}` : undefined}
                  onSelect={() => { onSelect(opt); setOpen(false); }}
                  className="rounded-sm cursor-pointer"
                >
                  <Check className={`w-4 h-4 mr-2 ${value === opt.codigo ? "opacity-100 text-blaze" : "opacity-0"}`} />
                  {opt.nome}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
